import React, { useState } from 'react';
import contact_img from '../../assets/images/contact-us-image.jpg';
import { FaUser } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { BiMessageAltDetail } from 'react-icons/bi';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import PhoneInput, { formatPhoneNumber } from 'react-phone-number-input';
import { Helmet } from 'react-helmet';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        mobile: '',
        message: '',
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // console.log('Form Data:', formData);
            const res = await axios.post('https://api.admissionsbazaar.com/site/contact/', formData);
            console.log(res);
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                },
            });

            // Use the name field from the response data
            Toast.fire({
                icon: 'success',
                text: res.data.name,
                title: 'Submitted successfully. Thank you!',
            });

            navigate('/');
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Something went wrong!';
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: errorMessage,
            });
            console.error('Error submitting form:', error);
        }
    };
    return (
        <>
            <Helmet>
                <title>Contact Admission Bazaar | Dream • Discover • Succeed</title>
                <meta name="description" content="Contact Admission Bazaar for inquiries related to colleges and exams across India. Admission Bazaar is a modern admission platform helping students discover colleges, courses, and achieve their academic goals." />
                <meta name="keywords" content="contact, Admission Bazaar, colleges, exams, India, admissions" />
            </Helmet>
            <section class="breadcrumb-section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <h1 class="ab-1">Contact Us</h1>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li class="breadcrumb-item active" aria-current="page">Contact Us</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5 contact-us-section">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-lg-12">
                            <div className="p-4 text-center rounded shadow-sm" style={{ background: '#f8fafc' }}>
                                <h5 className="mb-2 font-semibold">Admission Bazaar Support</h5>
                                <p className="mb-1"><strong>Support Email:</strong>{' '}
                                    <a href="mailto:Admissionsbazaar@gmail.com">Admissionsbazaar@gmail.com</a>
                                </p>
                                <p className="mb-0"><strong>Support Number:</strong>{' '}
                                    <a href="tel:+919479469454">+91 9479469454</a>
                                </p>
                                <p className="mt-2 mb-0 text-muted">Dream • Discover • Succeed</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="p-0 ml-auto col-lg-7">
                            <div className="book-now wow bounceIn">
                                <div className="text-center section_heading">
                                    <div className="mb-1 small_heading">
                                        <span className="left_line" />
                                        <h6>Contact Us</h6>
                                        <span className="right_line" />
                                    </div>
                                </div>
                                <form className="row align-items-center" onSubmit={handleSubmit}>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group custom-field">
                                            <div className="custom-field-icon">
                                                <FaUser />
                                            </div>
                                            <input
                                                type="text"
                                                className="custom-form-control"
                                                placeholder="Name"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group custom-field">
                                            <div className="custom-field-icon">
                                                <FiMail />
                                            </div>
                                            <input
                                                type="email"
                                                name="email"
                                                className="custom-form-control"
                                                placeholder="Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="input-group custom-field">
                                            <div className="custom-field-icon">
                                                <BiMessageAltDetail />
                                            </div>
                                            <input
                                                type="text"
                                                name="subject"
                                                className="custom-form-control"
                                                placeholder="Subject"
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <PhoneInput
                                            placeholder="Enter phone number"
                                            value={formData.mobile}
                                            onChange={(value) =>
                                                setFormData({
                                                    ...formData,
                                                    mobile: value,
                                                })
                                            }
                                            className="form-control"
                                        />
                                        {/* Display formatted phone number */}
                                        {formData.mobile && (
                                            <span className="text-sm text-gray-500">
                                                National: {formatPhoneNumber(formData.mobile)}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-12">
                                        <div className="input-group custom-field">
                                            <textarea
                                                className="custom-form-control"
                                                rows={4}
                                                cols={100}
                                                name="message"
                                                placeholder="Type Your Message...."
                                                value={formData.message}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="text-center col-12 book-now-btn">
                                        <button type="submit" className="book-btn" disabled={formData.submitting}>
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="p-0 col-lg-5">
                            <div className="contact-img">
                                <img src={contact_img} className="img-fluid" alt="contact-us" />
                            </div>
                        </div>
                    </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
            </section>
        </>
    );
};

export default Contact;
